import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=151a1f1d&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"
import style0 from "./Btn.vue?vue&type=style&index=0&id=151a1f1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a1f1d",
  null
  
)

export default component.exports